import React, { useState, useEffect } from "react";
import { getDataFromConfig, getTableButtonMap } from "../../../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import PreviewTable from "./PreviewTable/PreviewTable";
import "./toggleButtons.css";
interface ToggleButtonsProps {
  kpi: any;
  defaultConfigGlobal : Record<string,any>;
}

const ToggleButtons: React.FC<ToggleButtonsProps> = ({ kpi ,defaultConfigGlobal}) => {
  // Sort buttons according to their id
  const buttons = (
    kpi.buttons 
  )
  const [selectedButton, setSelectedButton] = useState<Record<string, any>>(
    buttons[0]
  );
  // Sort tables according to their id
  const tableSummaries = getDataFromConfig(
    "KPI_detail_summary_tables",
    kpi.id,
    defaultConfigGlobal
  )
const tableButtonMap = getTableButtonMap(kpi.id,buttons,tableSummaries)
  
  useEffect(() => {
    setSelectedButton(buttons[0]);
  }, [buttons]);
  return (
    <div className="kpi-preview-toggle-button-preview-container">
      <div className="kpi-preview-toggle-button-group">
        {buttons.map((button: Record<string, any>) => (
          <button
            key={button.id}
            className={`kpi-preview-toggle-button ${
              selectedButton?.id === button.id ? "kpi-preview-button-selected" : ""
            }`}
            onClick={() => setSelectedButton(button)}
          >
            {button.label}
          </button>
        ))}
      </div>
      <div className="kpi-preview-table-content">
        {selectedButton && tableButtonMap[selectedButton.id] && (
          <PreviewTable table_summary={tableButtonMap[selectedButton.id]} />
        )}
      </div>
    </div>
  );
};

export default ToggleButtons;
